module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_3.04c71a13.mp4";